import styled from "styled-components/macro";

import { SecondaryStyles } from "./Styles";

const SlimButton = styled.button`
  ${({
    theme,
    disabled,
    color,
    backgroundColor,
    borderColor,
    fullWidth,
    verticalMargin,
    borderRadius = 1,
    borderSize = 0,
    horizontalMargin = 0,
  }) => `  
  opacity: ${disabled ? 0.25 : 1};
  ${disabled ? "cursor: not-allowed;" : "cursor: pointer;"};
  
  background: ${
    backgroundColor && theme.colors[backgroundColor]
      ? theme.colors[backgroundColor]
      : theme.colors.primary
  };

  font-weight: ${theme.fontWeights.bold};
  color: ${
    color && theme.colors[color] ? theme.colors[color] : theme.colors.white
  };
  text-decoration: none;
  border-style: solid;
  border-width: ${borderSize}px;
  border-color: ${
    borderColor && theme.colors[borderColor]
      ? theme.colors[borderColor]
      : theme.colors.primary
  };
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  &:focus {
    outline: none;
  }
  ${theme.active}
  &:active {
    background: rgba(200, 200, 200, 0.59);
  }
  :not(:active) {
    transition: all linear 300ms;
  }
  min-height: 2em;
  padding: ${theme.space[1]}px ${theme.space[2]}px;
  ${
    verticalMargin
      ? `margin-top: ${theme.space[verticalMargin]}px; margin-bottom: ${theme.space[verticalMargin]}px;`
      : ""
  }
  ${
    horizontalMargin
      ? `margin-left: ${theme.space[horizontalMargin]}px; margin-right: ${theme.space[horizontalMargin]}px;`
      : ""
  }
  ${!verticalMargin && !horizontalMargin ? "margin: 0px;" : ""}
  ${fullWidth ? "width: 100%;" : ""}
   border-radius: ${
     typeof borderRadius === "number"
       ? `${theme.radii[borderRadius]}px`
       : borderRadius
   };
   &:hover:enabled {
      background: ${theme.colors.primaryHighlight};
   }
   transition: ${theme.transitions[0]};
  
  `}
`;

export default SlimButton;

export const SlimSecondaryButton = styled(SlimButton)(SecondaryStyles);
